<template>
  <b-form-group role="group">
    <label :for="name" @click="setFocus"><slot name="label"></slot></label>
    <b-input-group :prepend="prepend" :append="append">
      <b-form-input
        :class="inputClasses"
        :state="vState"
        :id="name"
        :name="name"
        :type="type"
        :value="value"
        :placeholder="placeholder"
        :ref="name"
        @input="updateInput"
        @change="emitBlur"
        :disabled="disabled"
        :readonly="readonly"></b-form-input>
      <b-form-invalid-feedback :id="name">
        <div @click="setFocus">
          {{validationMessage}}
        </div>
      </b-form-invalid-feedback>
    </b-input-group>
  </b-form-group>
</template>

<script>
export default {
  props: {
    'value': {
      type: [String, Number],
      default: ''
    },
    'type': {
      type: String,
      default: 'text'
    },
    'inputClasses': {
      type: String,
      default: ''
    },
    'name': String,
    'placeholder': [String, Number],
    'required': Boolean,
    'v': Object,
    'disabled': Boolean,
    'readonly': Boolean,
    'prepend': {
      type: [String],
      default: ''
    },
    'append': {
      type: [String],
      default: ''
    }
  },
  computed: {
    vState () {
      if (!this.v) {
        return null
      } else {
        return (!this.v.$dirty) ? null : (this.v.$dirty && !this.v.$invalid)
      }
    },
    validationMessage () {
      let str = ''

      if (this.v) {
        if (!this.v.required) {
          str = 'This field is required'
        } else if (!this.v.email) {
          str = 'Invalid E-Mail Address'
        }
      }

      return str
    }
  },
  methods: {
    updateInput (value) {
      this.$emit('input', value)
    },
    emitBlur () {
      this.$emit('blur')
    },
    setFocus () {
      this.$el.querySelector('input').focus()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Common/textFields.vue